module.exports = __webpack_public_path__ + "img/sort-icon-4.d416fbcb.png";